import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import Immutable from 'immutable';
import hashCode from '../../hash-code/hash-code';
import AdaViolationRecord from '../../records/AdaViolationRecord';
import * as actions from './actions';
var StateRecord = Immutable.Record({
  violations: Immutable.Map(),
  scanningEnabled: false
});
var initialState = new StateRecord();

function adaViolationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions.ADA_VIOLATIONS_SET:
      {
        if (!state.scanningEnabled) {
          return state;
        }

        var updatedMap = state.violations;
        action.violations.map(function (violation) {
          var violationHashId = hashCode(JSON.stringify(violation).replace(/[A-Z]{6,10}/g, 'XXXXXXX'));
          var violationRecord = new AdaViolationRecord({
            hashId: violationHashId,
            violationId: violation.id,
            impact: violation.impact,
            description: violation.description,
            help: violation.help,
            helpUrl: violation.helpUrl,
            nodes: violation.nodes,
            tags: violation.tags,
            expanded: false
          });
          updatedMap = updatedMap.set(violationHashId, violationRecord);
          return updatedMap;
        });
        return state.merge({
          violations: updatedMap
        });
      }

    case actions.ADA_VIOLATION_TOGGLE:
      {
        var violationHashId = action.violationHashId;
        return state.merge({
          violations: state.violations.update(violationHashId, function (violation) {
            return violation.merge({
              expanded: !violation.expanded
            });
          })
        });
      }

    case actions.ADA_VIOLATIONS_CLEAR:
      return state.merge({
        violations: Immutable.Map()
      });

    case actions.ADA_SCANNING_TOGGLE:
      global.suspendAxeScanning = state.scanningEnabled;
      return state.merge({
        scanningEnabled: !state.scanningEnabled
      });

    default:
      return state;
  }
}

export default adaViolationsReducer;